const DIGITS_ONLY_REGEX = /\D/g;

export const formatCurrencyBR = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return '';
  return number.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const normalizeCurrencyInputBR = (value) => {
  const digits = String(value ?? '').replace(DIGITS_ONLY_REGEX, '');
  if (!digits) return '';
  const number = Number(digits) / 100;
  if (!Number.isFinite(number)) return '';
  return formatCurrencyBR(number);
};

export const normalizeDecimalInputBR = (value, maxDecimals = 2) => {
  const raw = String(value ?? '').replace(/[^\d,]/g, '');
  if (!raw) return '';

  const hasComma = raw.includes(',');
  const [rawInt = '', rawDec = ''] = raw.split(',');
  let intPart = rawInt.replace(/^0+(?=\d)/, '');
  if (!intPart) intPart = '0';

  const decPart = rawDec.slice(0, maxDecimals);
  if (!hasComma) return intPart;
  return `${intPart},${decPart}`;
};

export const normalizeIntegerInputBR = (value) => {
  return String(value ?? '').replace(DIGITS_ONLY_REGEX, '');
};

export const parseDecimalBR = (value) => {
  const raw = String(value ?? '').trim();
  if (!raw) return null;
  const normalized = raw.replace(/\./g, '').replace(',', '.');
  const number = Number(normalized);
  return Number.isFinite(number) ? number : null;
};

export const parseCurrencyBR = (value) => {
  return parseDecimalBR(value);
};

export const parseIntegerBR = (value) => {
  const digits = normalizeIntegerInputBR(value);
  if (!digits) return null;
  const number = Number(digits);
  return Number.isFinite(number) ? number : null;
};

export const formatDecimalBR = (value, maxDecimals = 2, minDecimals = 0) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return '';
  return number.toLocaleString('pt-BR', {
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals,
  });
};

export const formatIntegerBR = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return '';
  return Math.trunc(number).toLocaleString('pt-BR');
};
